// extracted by mini-css-extract-plugin
export default {"title":"mgTNb","subtitle":"vYZ3D","firstTicket":"YRAsT","lastTicket":"sCc2f"};